export default "__VITE_ASSET__CaoItrL___"